import { createBrowserRouter, Navigate, RouterProvider } from 'react-router';
import { PagePlaceholder } from './components/PagePlaceholder';
import { AbonamenteListPage } from './features/abonamente/AbonamenteListPage';
import { AuthGuard } from './features/auth/AuthGuard';
import { LoginRoute } from './features/auth/LoginRoute';
import { CheltuieliListPage } from './features/cheltuieli/CheltuieliListPage';
import { ClientiListPage } from './features/clienti/ClientiListPage';
import { ContabilitatePage } from './features/contabilitate/ContabilitatePage';
import { DashboardPage } from './features/dashboard/DashboardPage';
import { FacturaEditorPage } from './features/facturi/FacturaEditorPage';
import { FacturaViewPage } from './features/facturi/FacturaViewPage';
import { FacturiListPage } from './features/facturi/FacturiListPage';
import { FirmeListPage } from './features/firme/FirmeListPage';
import { ProduseListPage } from './features/produse/ProduseListPage';
import { SeriiListPage } from './features/serii/SeriiListPage';
import { SetariPage } from './features/setari/SetariPage';
import { AppLayout } from './layout/AppLayout';

const router = createBrowserRouter([
  { path: '/login', element: <LoginRoute /> },
  {
    element: <AuthGuard />,
    children: [
      {
        element: <AppLayout />,
        children: [
          { index: true, element: <DashboardPage /> },
          { path: 'facturi', element: <FacturiListPage /> },
          // Static before dynamic is only cosmetic — React Router ranks
          // `/facturi/noua` above `/facturi/:id` regardless of order.
          { path: 'facturi/noua', element: <FacturaEditorPage /> },
          { path: 'facturi/:id', element: <FacturaViewPage /> },
          { path: 'facturi/:id/editare', element: <FacturaEditorPage /> },
          { path: 'cheltuieli', element: <CheltuieliListPage /> },
          { path: 'contabilitate', element: <ContabilitatePage /> },
          { path: 'abonamente', element: <AbonamenteListPage /> },
          { path: 'clienti', element: <ClientiListPage /> },
          { path: 'produse', element: <ProduseListPage /> },
          { path: 'firme', element: <FirmeListPage /> },
          { path: 'serii', element: <SeriiListPage /> },
          { path: 'setari', element: <SetariPage /> },
          { path: '*', element: <PagePlaceholder title="Pagină negăsită" /> },
        ],
      },
    ],
  },
  { path: '*', element: <Navigate to="/" replace /> },
]);

export function App() {
  return <RouterProvider router={router} />;
}
